// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3zlPQ","title":"Header_title__2G1fJ","side":"Header_side__2O3WD"};